import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  ArrayField,
  Datagrid
} from "react-admin";

const SportSeasonShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="sportCode" />
        <TextField source="seasonCode" />
        <BooleanField source="isCurrent" />
        <ArrayField source="schedulePeriods">
          <Datagrid>
            <TextField source="label" />
            <TextField source="startDate" />
            <TextField source="endDate" />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};

export default SportSeasonShow;
